import { Injectable } from "@angular/core";
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {delay, tap, map} from "rxjs/operators";
import { AppService } from "@irb/app.service";
import { IUserDetails } from "@irb/app.model";
import { IModel, IModelReplaceSecurity } from "@irb/irb-clients/irb-clients.model";

@Injectable({
  providedIn: "root",
})
export class ModelsService {
  private userDetails: IUserDetails;
  _filterCriteria: string;
  _sortCriteria: string = "";
  inventorySort: string = "";

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "Sat, 01 Jan 2000 00:00:00 GMT",
    }),
  };
  currentModelsCountDisplayed: number = null;

  constructor(private readonly http: HttpClient, private appService: AppService, private _http: HttpClient) {
    this.getUserDetails();
  }

  getUserDetails(): void {
    this.appService.getUserDetails().subscribe((res: IUserDetails) => {
      if (res) {
        this.userDetails = res;
      }
    });
  }

  getModels(params: any, selectedSecurityIds: any): Observable<HttpResponse<Models[]>> {
    const headers = new HttpHeaders({
      'X-HTTP-Method-Override':'GET',
      'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
    });
    let sort = "";
    let filterKeys = "";
    if (params.request.sortModel.length > 0) {
      const sortColumn = params.request.sortModel[0].colId;
      const sortOrder = params.request.sortModel[0].sort === "asc" ? "+" : "-";
      sort = "&sort(" + sortOrder + sortColumn + ")";
    }
    if (params.request.filterModel && params.request.filterModel["name"]) {
      if (params.request.filterModel["name"].filter) {
        const encodedName = encodeURIComponent(params.request.filterModel["name"].filter);

        filterKeys = filterKeys + "&name=" + encodedName;
      }
    }

    if (params.request.filterModel && params.request.filterModel["type"]) {
      const statusList = params.request.filterModel["type"].values;
      if (statusList) {
        filterKeys = filterKeys + "&type=" + statusList;
      }
    }

    if (params.request.filterModel && params.request.filterModel["status"]) {
      const statusList = params.request.filterModel["status"].values;
      if (statusList) {
        filterKeys = filterKeys + "&status=" + statusList;
      }
    }

    /*if (params.request.filterModel && params.request.filterModel['modelProviderName']) {
  if (params.request.filterModel['modelProviderName'].values) {
      filterKeys = filterKeys + '&modelProviderIds=' + selectedMangerIds;
  }
}*/
    if (params.request.filterModel && params.request.filterModel["quickfilter"]) {
      if (params.request.filterModel["quickfilter"].withoutUnread) {
        filterKeys = filterKeys + "&isRead=" + "false";
      }
      if (params.request.filterModel["quickfilter"].withoutIncomplete) {
        filterKeys = filterKeys + "&status=" + "Incomplete";
      }
      if (params.request.filterModel["quickfilter"].isPaused) {
        filterKeys = filterKeys + "&allowAutoRebalOnModelUpdate=" + "PAUSED_FOR_REV";
      }
    }

    if (params.request.filterModel && params.request.filterModel["isMMCModel"]) {
      const isMMCModelResults = params.request.filterModel["isMMCModel"].values;
      if (isMMCModelResults && isMMCModelResults.length && isMMCModelResults.length === 1) {
        let isMMCModel = isMMCModelResults.join(',').replace('Yes', true).replace('No', false);
        filterKeys = filterKeys + "&isMMCModel=" + isMMCModel;
      }
    }

    if (params.request.filterModel && params.request.filterModel["componentSecurity"]) {
      const componentSecurity = params.request.filterModel["componentSecurity"].values;

      if (componentSecurity) {
        filterKeys = filterKeys + "&componentSecurity=" + selectedSecurityIds;
      }
    }

    if (params.request.filterModel && params.request.filterModel["createdBy"]) {
      const createdBy = params.request.filterModel["createdBy"].values;

      if (createdBy) {
        filterKeys = filterKeys + "&createdBy=" + createdBy;
      }
    }

    if (params.request.filterModel && params.request.filterModel["modifiedBy"]) {
      const modifiedBy = params.request.filterModel["modifiedBy"].values;

      if (modifiedBy) {
        filterKeys = filterKeys + "&modifiedBy=" + modifiedBy;
      }
    }

    if (params.request.filterModel && params.request.filterModel["createdDate"]) {
      let fromDate = params.request.filterModel["createdDate"].filterFrom;
      let toDate = params.request.filterModel["createdDate"].filterTo;
      const filterFromToDateValue = "&createdFromDate=" + fromDate + "&createdToDate=" + toDate;
      filterKeys = filterKeys + filterFromToDateValue;
    }

    if (params.request.filterModel && params.request.filterModel["editedDate"]) {
      let fromDate = params.request.filterModel["editedDate"].filterFrom;
      let toDate = params.request.filterModel["editedDate"].filterTo;
      const filterFromToDateValue = "&modifiedFromDate=" + fromDate + "&modifiedToDate=" + toDate;
      filterKeys = filterKeys + filterFromToDateValue;
    }

    /*if (params.request.filterModel && params.request.filterModel["finscoreFilter"]) {
      let minvalue = params.request.filterModel["finscoreFilter"].filter;
      let maxvalue = params.request.filterModel["finscoreFilter"].filterTo;
      if ((minvalue || maxvalue) && minvalue >= 1 && maxvalue <= 100) {
        minvalue = minvalue >= 1 && minvalue <= 100 ? minvalue : null;
        maxvalue = maxvalue >= 1 && maxvalue <= 100 ? maxvalue : null;
        const minmaxvalue = minvalue + "-" + maxvalue;
        filterKeys = filterKeys + "&finscore=" + minmaxvalue;
      }
    }*/

    if (params.request.filterModel && params.request.filterModel["componentModels"]) {
      const componentModels = params.request.filterModel["componentModels"].values;

      if (componentModels) {
        filterKeys = filterKeys + "&componentSecurity=" + "&componentModel=" + selectedSecurityIds + "&inBlendedModels=";
      }
    }

    if (params.request.filterModel && params.request.filterModel["inBlendedModels"]) {
      const inBlendedModels = params.request.filterModel["inBlendedModels"].values;

      if (inBlendedModels) {
        filterKeys = filterKeys + "&componentSecurity=" + "&blendedModel=" + selectedSecurityIds + "&componentModels=";
      }
    }

    if (params.request.filterModel && params.request.filterModel["isSyntaxModel"]) {
      const isSyntaxCModelResults = params.request.filterModel["isSyntaxModel"].values;
      if (isSyntaxCModelResults && isSyntaxCModelResults.length && isSyntaxCModelResults.length === 1) {
        let isSyntaxModel = isSyntaxCModelResults.join(',').replace('Yes', true).replace('No', false);
        filterKeys = filterKeys + "&isSyntaxModel=" + isSyntaxModel;
      }
    }

    if (filterKeys) {
      this._filterCriteria = "&Filter=" + filterKeys;
    }else{
      this._filterCriteria = "";
    }
    this.inventorySort = sort;
    return this.http
      .post<Models[]>("/irebalone/model/get-models-inv" + "?" + sort,{Filter:filterKeys},{ headers: headers, observe: "response" })
      .pipe(
        delay(1000),
        tap((_res) => {
          //console.log("response header" + res.headers.get("Content-Range"));
        })
      );
  }

  getModelsCount(): Observable<ModelsCount> {
    return this.http.get<ModelsCount>("/irebalone/model/get-model-inv-counts").pipe(delay(1000));
  }

  getUreadAndIncomplteCountCount(): Observable<UnreadAndIncompleteModelsCount> {
    return this.http.get<UnreadAndIncompleteModelsCount>("/irebalone/model/get-model-inv-counts").pipe(delay(1000));
  }

  getModelManager(): Observable<IModelFilterDDList> {
    return this.http.get<IModelFilterDDList>("/irebalone/mmc/get-model-providers").pipe(delay(1000));
  }

  getSecuritiesDropDown(): Observable<IDropDownDTO> {
    return this.http.get<IDropDownDTO>("/irebalone/model/get-securities-drop-down").pipe(delay(1000));
  }

  getCreatedByModifiedBy(): Observable<ICreatedByModifiedBy> {
    return this.http.get<ICreatedByModifiedBy>("/irebalone/model/get-created-by-modified-by").pipe(delay(1000));
  }

  exportModelDetails(data: IModelExportRequest): Observable<any> {
    data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : "");
    data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : "");
    return this.http.post("/irebalone/model/async/get-selected-models-by-ids", JSON.stringify(data), this.httpOptions);
  }

  exportSecurityModelTargets(data: IModelExportRequest): Observable<any> {
    data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : "");
    data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : "");
    return this.http.post("/irebalone/model/async/export-security-models-targets", data);
  }

  exportBlendedModelTargets(data: IModelExportRequest): Observable<any> {
    data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : "");
    data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : "");
    return this.http.post("/irebalone/model/async/export-blended-models-targets", data);
  }

  importSecurityModels(formData: any): Observable<Object> {
    return this._http.post("/irebalone/model/import-security-models", formData, { responseType: "text" as "json" });
  }

  importSecurityModelsAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/model/async/import-security-models", formData);
  }

  validateImportSecModelsAsyncStatus(statusId: string): Observable<Object> {
    if (!/^[0-9]+$/.test(statusId)) {
      throw new Error("Invalid character payload.");
    } else {
      const e = encodeURIComponent(statusId);
      const u = "/irebalone/model/async-import-security-models/*".replace("*",e)
      return this.http.get<any>(u, this.httpOptions).pipe(delay(1000));;
    }
  }

  updateImportSecurityModels(data: IModelImportSave): Observable<any> {
    return this._http.post("/irebalone/model/save-imported-security-models", data, this.httpOptions);
  }

  importBlendedModels(formData: any): Observable<Object> {
    return this._http.post("/irebalone/model/import-blended-models", formData, { responseType: "text" as "json" });
  }

  updateImportBlendedModels(data: object): Observable<any> {
    return this._http.post("/irebalone/model/save-imported-blended-models", data, this.httpOptions);
  }

  createSecurityModel(data: ICreateModel): Observable<any> {
    return this._http.post("/irebalone/model/create-model", data, this.httpOptions);
  }

  getIdsToBeProcessed(data: IModelExportRequest): Observable<any> {
    data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : "");
    data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : "");
    return this.http.post("/irebalone/model/get-selected-models-by-ids", data, this.httpOptions);
  }

  getSecuritiesOfSelectedModel(data: any): Observable<any>{
    return this.http.post("/irebalone/model/get-securities-of-selected-model", data, this.httpOptions);
  }

  replacesecurity(data: IModelReplaceSecurity): Observable<any>{
    return this.http.post("/irebalone/model/replace-security", data, this.httpOptions);
  }

  deleteSelectedModel(deleteSecurityModels: IModel[]): Observable<any> {
    const sortParam = this._sortCriteria !== undefined ? this._sortCriteria : "";
    const filterParam = this._filterCriteria !== undefined ? this._filterCriteria : "";
    return this.http.post<any>("/irebalone/model/async/delete-selected-models", JSON.stringify(deleteSecurityModels), this.httpOptions);
  }

  getDeleteSelectedModelStatus(statusId: string): Observable<Object> {
    return this.http.get("/irebalone/model/get-async-status/" + statusId);
  }

  getPortfoliosIds(data: IModelExportRequest): Observable<any> {
    data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : "");
    data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : "");
    return this.http.post("/irebalone/model/get-model-portfolios-ids", data, this.httpOptions);
  }

  getFinmasonAuthToken(): Observable<any> {
    return this.http.get("/irebalone/sso/finmason/auth-info", this.httpOptions);
  }

  getSecurityModelNamesDropDown(): Observable<ISecurityModelNamesList> {
    return this.http.get<ISecurityModelNamesList>("/irebalone/model/get-security-model-names").pipe(delay(1000));
  }

  getBlendedModelNamesDropDown(): Observable<IBlendedModelNamesList> {
    return this.http.get<IBlendedModelNamesList>("/irebalone/model/get-blended-model-names").pipe(delay(1000));
  }
  
  getFinScorePortfolioRequest(data:any): Observable<any> {     
    return this.http.get('/irebalone/portfolios/finmason/portfolio/'+data,this.httpOptions);
  }

  clearCriteria() {
    this._filterCriteria = "";
    this._sortCriteria = "";
    this.inventorySort = "";
  }

  getCurrentModelsCountDisplayed() {
    return this.currentModelsCountDisplayed;
  }

  setCurrentModelsCountDisplayed(currentModelsCountDisplayed: number) {
    return this.currentModelsCountDisplayed = currentModelsCountDisplayed;
  }

  getPrevnextModel(startRow: any): any {
    let endRow = startRow + 1;
    const headers = new HttpHeaders({
      'X-HTTP-Method-Override':'GET',
      'Filter-Item':'items=' + startRow + '-' + (--endRow)
    });

    const filterKeys = this._filterCriteria === "" ? "" : this._filterCriteria.replace("&Filter=", "");
    return this.http
        .post<Models[]>("/irebalone/model/get-models-inv" + "?" + this.inventorySort, {Filter: filterKeys}, {
          headers: headers,
          observe: "response"
        })
        .pipe(
            delay(1000),
            tap((_res) => {
              //console.log("response header" + res.headers.get("Filter-Count"));
            })
        );
  }

  actionStatusCheck(actionStatusId: any) {
    return this.http.get('/irebalone/model/save-imported-security-models-status/' + actionStatusId).pipe(delay(1000));
  }

  saveImportedBlendedModelsAsynch(data: any) {
    return this._http.post("/irebalone/model/save-imported-blended-models-asynch", data, this.httpOptions);
  }

  saveImportedBlendedModelsStatus(actionStatusId: any) {
    return this.http.get('/irebalone/model/save-imported-blended-models-status/' + actionStatusId);
  }

  validateImportedBlendedModelsAsynch(data: any) {
    return this._http.post("/irebalone/model/async/validate-import-blended-models", data);
  }
  validateImportedBlendedModelsStatusCheck(actionStatusId: any) {
    return this.http.get('/irebalone/model/async/validate-import-blended-models/' + actionStatusId);
  }

  validateSecurityModelName(securityModelName: any, type: string) {
    const modelExistsDTO = {"modelName": securityModelName, "type": type};
    return this._http.post("/irebalone/model/is-model-exists", JSON.stringify(modelExistsDTO), this.httpOptions);
  }

  defineResponse(res: any) {
    return  res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
  }

  getSyntaxRedirect() {
    return this.http.get(`/irebalone/model/syntax-redirect`).pipe(map(res => this.defineResponse(res)));
  }

}



export interface Models {
  name: string;
  description: string;
  type: string;
  status: string;
}

export interface ModelsCount {
  incompleteCount: number;
  totalInvCount: number;
}

export interface UnreadAndIncompleteModelsCount {
  incompleteCount: number;
  unreadCount: number;
  pausedCount: number;
  withoutIncomplete?: boolean;
  withoutUnread?: boolean;
  isPaused?: boolean;
}

export interface IModelFilterDDList {
  identifier: any;
  items: Array<IModelManager>;
  label: string;
}

export interface IModelManager {
  id: any;
  name: string;
}

export interface IDropDownItemDTO {
  securityId: number;
  securitySymbol: string;
  /*securityDescription: string;
  securityType: string;
  securityCatagory: string;
  targetPercnt: number;
  extSharePrice: number;*/
}

export interface IDropDownDTO {
  identifier: string;
  label: string;
  items: Array<IDropDownItemDTO>;
}

export interface ICreatedByModifiedBy {
  modifiedByList: Array<string>;
  createdByList: Array<string>;
}

export interface IModelExportRequest {
  isSelectAll: boolean;
  selectedIds?: Array<IDeleteModel>;
  deselectedIds?: Array<number>;
  filter?: string;
  sort?: string;
  includeModelDetails: boolean;
}

export interface IModelDropdownRequest {
  selectedIds?: Array<IDeleteModel>;
  isDraft:boolean;
}

interface IDeleteModel {
  modelId: number;
  versionId: number;
}

export interface IModelImportSave {
  modelsToAdd?: [][];
  securitiesToAdd?: [][];
}

export interface ICreateModel {
  modelName: string;
  modelDescription: string;
  modelType: string;
}

export interface BlendedResult {
  name: string;
  status: string;
  action: string;
}

export interface ISecurityModelNamesList {
  identifier: any;
  items: Array<ISecurityModelManager>;
  label: string;
}

export interface ISecurityModelManager {
  id: any;
  name: string;
}

export interface IBlendedModelNamesList {
  identifier: any;
  items: Array<IBlendedModelManager>;
  label: string;
}

export interface IBlendedModelManager {
  id: any;
  name: string;
}
